(function () {

  'use strict';


  /* =========================================================
     ELEMENTS
     ========================================================= */

  const sticky =
    document.getElementById(
      'R4WStickyAddToCart'
    );


  if (!sticky) {
    return;
  }


  const image =
    document.getElementById(
      'R4WStickyImage'
    );


  const title =
    document.getElementById(
      'R4WStickyTitle'
    );


  const variantText =
    document.getElementById(
      'R4WStickyVariant'
    );


  const price =
    document.getElementById(
      'R4WStickyPrice'
    );


  const buttonPrice =
    document.getElementById(
      'R4WStickyButtonPrice'
    );


  const button =
    document.getElementById(
      'R4WStickyButton'
    );


  const quantityInput =
    document.getElementById(
      'R4WStickyQuantity'
    );


  const minus =
    document.getElementById(
      'R4WStickyMinus'
    );


  const plus =
    document.getElementById(
      'R4WStickyPlus'
    );


  /* =========================================================
     PRODUCT DATA
     ========================================================= */

  const dataElement =
    document.getElementById(
      'R4WStickyProductData'
    );


  let productData;


  try {

    productData =
      JSON.parse(
        dataElement.textContent
      );

  } catch (error) {

    console.error(
      'R4W Sticky ATC: Product data error',
      error
    );

    return;

  }


  /* =========================================================
     FIND PRODUCT FORM
     ========================================================= */

  function getProductForm() {

    const selectors = [

      'form[action*="/cart/add"]',

      'form.product-single__form',

      'form.product-form',

      'form[data-product-form]'

    ];


    for (
      let i = 0;
      i < selectors.length;
      i++
    ) {

      const form =
        document.querySelector(
          selectors[i]
        );


      if (form) {
        return form;
      }

    }


    return null;

  }


  let productForm =
    getProductForm();


  /* =========================================================
     GET VARIANT ID
     ========================================================= */

  function getCurrentVariantId() {

    if (!productForm) {

      productForm =
        getProductForm();

    }


    if (!productForm) {
      return null;
    }


    const variantInput =
      productForm.querySelector(
        '[name="id"]'
      );


    if (
      variantInput &&
      variantInput.value
    ) {

      return String(
        variantInput.value
      );

    }


    return null;

  }


  /* =========================================================
     GET CURRENT QUANTITY
     ========================================================= */

  function getCurrentQuantity() {

    if (!productForm) {
      return 1;
    }


    const quantityInput =
      productForm.querySelector(
        '[name="quantity"]'
      );


    if (
      quantityInput &&
      quantityInput.value
    ) {

      const quantity =
        parseInt(
          quantityInput.value,
          10
        );


      if (
        Number.isFinite(quantity) &&
        quantity > 0
      ) {

        return quantity;

      }

    }


    return 1;

  }


  /* =========================================================
     FIND VARIANT
     ========================================================= */

  function getCurrentVariant() {

    const variantId =
      getCurrentVariantId();


    if (!variantId) {

      return (
        productData.variants.find(
          function (variant) {

            return variant.available;

          }
        ) ||
        productData.variants[0]
      );

    }


    return (
      productData.variants.find(
        function (variant) {

          return (
            String(variant.id) ===
            String(variantId)
          );

        }
      ) ||
      productData.variants[0]
    );

  }


  /* =========================================================
     UPDATE STICKY PRODUCT
     ========================================================= */

  function updateStickyProduct() {

    const variant =
      getCurrentVariant();


    if (!variant) {
      return;
    }


    /* TITLE */

    if (title) {

      title.textContent =
        productData.title;

    }


    /* VARIANT */

    if (variantText) {

      let text =
        variant.title || '';


      if (
        text === 'Default Title'
      ) {

        text = '';

      }


      variantText.textContent =
        text;

    }


    /* PRICE */

    if (price) {

      price.textContent =
        variant.priceFormatted || '';

    }


    if (buttonPrice) {

      buttonPrice.textContent =
        variant.priceFormatted || '';

    }


    /* IMAGE */

    if (
      image &&
      variant.image
    ) {

      image.src =
        variant.image;

    }


    /* BUTTON */

    if (button) {

      if (
        variant.available
      ) {

        button.disabled =
          false;

        button.classList.remove(
          'is-disabled'
        );

      } else {

        button.disabled =
          true;

        button.classList.add(
          'is-disabled'
        );

        const text =
          button.querySelector(
            '.r4w-sticky-atc__button-text'
          );


        if (text) {

          text.textContent =
            'SOLD OUT';

        }

      }

    }

  }


  /* =========================================================
     SYNC QUANTITY
     ========================================================= */

  function syncQuantityToProductForm() {

    if (!productForm) {

      productForm =
        getProductForm();

    }


    if (!productForm) {
      return;
    }


    const mainQuantity =
      productForm.querySelector(
        '[name="quantity"]'
      );


    if (!mainQuantity) {
      return;
    }


    const value =
      parseInt(
        quantityInput.value,
        10
      );


    const safeValue =
      Number.isFinite(value) &&
      value > 0
        ? value
        : 1;


    mainQuantity.value =
      safeValue;


    /*
     * Trigger change in case another
     * Shopify app/theme listener
     * is watching quantity.
     */

    mainQuantity.dispatchEvent(
      new Event(
        'change',
        {
          bubbles: true
        }
      )
    );

  }


  /* =========================================================
     QUANTITY
     ========================================================= */

  if (minus) {

    minus.addEventListener(
      'click',
      function () {

        let value =
          parseInt(
            quantityInput.value,
            10
          ) || 1;


        value =
          Math.max(
            1,
            value - 1
          );


        quantityInput.value =
          value;


        syncQuantityToProductForm();

      }
    );

  }


  if (plus) {

    plus.addEventListener(
      'click',
      function () {

        let value =
          parseInt(
            quantityInput.value,
            10
          ) || 1;


        value += 1;


        quantityInput.value =
          value;


        syncQuantityToProductForm();

      }
    );

  }


  if (quantityInput) {

    quantityInput.addEventListener(
      'change',
      function () {

        let value =
          parseInt(
            quantityInput.value,
            10
          ) || 1;


        value =
          Math.max(
            1,
            value
          );


        quantityInput.value =
          value;


        syncQuantityToProductForm();

      }
    );

  }


  /* =========================================================
     LISTEN TO PRODUCT FORM CHANGES
     ========================================================= */

  function handleProductFormChange() {

    productForm =
      getProductForm();

    updateStickyProduct();

    const quantity =
      getCurrentQuantity();


    if (
      quantityInput &&
      document.activeElement !==
        quantityInput
    ) {

      quantityInput.value =
        quantity;

    }

  }


  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target &&
        productForm &&
        productForm.contains(
          event.target
        )
      ) {

        handleProductFormChange();

      }

    }
  );


  /*
   * Some themes/apps update the
   * variant hidden input without
   * firing a normal change event.
   *
   * Watch the form for changes.
   */

  let lastVariantId =
    getCurrentVariantId();


  setInterval(
    function () {

      const currentVariantId =
        getCurrentVariantId();


      if (
        currentVariantId !==
        lastVariantId
      ) {

        lastVariantId =
          currentVariantId;

        updateStickyProduct();

      }

    },
    250
  );


  /* =========================================================
     STICKY VISIBILITY
     ========================================================= */

  function findMainAddButton() {

    if (!productForm) {

      productForm =
        getProductForm();

    }


    if (!productForm) {
      return null;
    }


    const selectors = [

      '[name="add"]',

      'button[type="submit"]',

      'input[type="submit"]',

      '.product-form__cart-submit',

      '.add-to-cart'

    ];


    for (
      let i = 0;
      i < selectors.length;
      i++
    ) {

      const element =
        productForm.querySelector(
          selectors[i]
        );


      if (element) {
        return element;
      }

    }


    return null;

  }


  function updateVisibility() {

    const addButton =
      findMainAddButton();


    if (!addButton) {
      return;
    }


    const rect =
      addButton.getBoundingClientRect();


    /*
     * Sticky appears when the
     * original ATC button is
     * outside the viewport.
     */

    const isVisible =
      rect.top < window.innerHeight &&
      rect.bottom > 0;


    if (isVisible) {

      sticky.classList.remove(
        'is-visible'
      );

      sticky.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.classList.remove(
        'r4w-sticky-atc-visible'
      );

    } else {

      sticky.classList.add(
        'is-visible'
      );

      sticky.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'r4w-sticky-atc-visible'
      );

    }

  }


  /* =========================================================
     INTERSECTION OBSERVER
     ========================================================= */

  function setupObserver() {

    const addButton =
      findMainAddButton();


    if (!addButton) {

      /*
       * Retry because some Impulse
       * product forms are initialized
       * after page load.
       */

      setTimeout(
        setupObserver,
        500
      );

      return;

    }


    if (
      'IntersectionObserver'
      in window
    ) {

      const observer =
        new IntersectionObserver(
          function (entries) {

            const entry =
              entries[0];


            if (
              entry.isIntersecting
            ) {

              sticky.classList.remove(
                'is-visible'
              );

              sticky.setAttribute(
                'aria-hidden',
                'true'
              );

              document.body.classList.remove(
                'r4w-sticky-atc-visible'
              );

            } else {

              sticky.classList.add(
                'is-visible'
              );

              sticky.setAttribute(
                'aria-hidden',
                'false'
              );

              document.body.classList.add(
                'r4w-sticky-atc-visible'
              );

            }

          },
          {
            threshold: 0
          }
        );


      observer.observe(
        addButton
      );

    } else {

      window.addEventListener(
        'scroll',
        updateVisibility,
        {
          passive: true
        }
      );

    }

  }


  /* =========================================================
     STICKY ADD TO CART
     ========================================================= */

  if (button) {

    button.addEventListener(
      'click',
      function () {

        productForm =
          getProductForm();


        if (!productForm) {

          console.error(
            'R4W Sticky ATC: Product form not found.'
          );

          return;

        }


        const variant =
          getCurrentVariant();


        if (
          !variant ||
          !variant.available
        ) {

          return;

        }


        /* Sync variant */

        const variantInput =
          productForm.querySelector(
            '[name="id"]'
          );


        if (
          variantInput &&
          variant.id
        ) {

          variantInput.value =
            variant.id;

        }


        /* Sync quantity */

        syncQuantityToProductForm();


        /*
         * IMPORTANT:
         *
         * Submit the existing Shopify
         * product form.
         *
         * This preserves the normal
         * Impulse add-to-cart behavior.
         */

        button.classList.add(
          'is-loading'
        );


        const buttonText =
          button.querySelector(
            '.r4w-sticky-atc__button-text'
          );


        if (buttonText) {

          buttonText.textContent =
            'ADDING...';

        }


        try {

          if (
            typeof productForm.requestSubmit ===
            'function'
          ) {

            productForm.requestSubmit();

          } else {

            productForm.submit();

          }

        } catch (error) {

          console.error(
            'R4W Sticky ATC:',
            error
          );


          button.classList.remove(
            'is-loading'
          );


          if (buttonText) {

            buttonText.textContent =
              'ADD TO CART';

          }

        }


        /*
         * Reset button text shortly
         * after submission.
         *
         * The cart drawer/page will
         * be controlled by Impulse.
         */

        setTimeout(
          function () {

            button.classList.remove(
              'is-loading'
            );


            if (buttonText) {

              buttonText.textContent =
                'ADD TO CART';

            }

          },
          1500
        );

      }
    );

  }


  /* =========================================================
     INITIALIZE
     ========================================================= */

  updateStickyProduct();

  setupObserver();

  updateVisibility();


  window.addEventListener(
    'resize',
    updateVisibility,
    {
      passive: true
    }
  );

})();